<template>
    <div>
        <component :is="component" :items="elements"></component>
    </div>
</template>

<script>
import * as Layouts from "@/imports/layouts.js"

export default {
    computed: {
        component () {
            return this.findLayout()
        }
    },
    methods: {
        findLayout () {
            switch (this.layout) {
            case "TE": return Layouts.TravelEnglish
            case "BESD2": return Layouts.BESD
            case "BEDA": return Layouts.DiscussionAndAnalysis
            case "CJA2": return Layouts.ConversationJrAdvanced2
            case "CJB2": return Layouts.ConversationJrBasic2
            case "CJI2": return Layouts.ConversationJrIntermediate2
            case "PPJB": return Layouts.PatternPracticeJrBasic
            case "PPJI": return Layouts.PatternPracticeJrIntermediate
            case "PPJA": return Layouts.PatternPracticeJrAdvanced
            case "PH1": return Layouts.Phonics1
            case "BPE": return Layouts.BPEmailing
            case "BPM": return Layouts.BPMeeting
            case "BPN": return Layouts.BPNegotiation
            case "BPP": return Layouts.BPPresentation
            case "DD1": return Layouts.DailyDialogues1
            case "PRT1": return Layouts.PerfectReading1
            case "PRT2": return Layouts.PerfectReading2
            case "FTQA": return Layouts.FTQA
            case "FTDescription": return Layouts.FTDescription
            case "FTDebate": return Layouts.FTDebate
            case "HD1": return Layouts.HotelDialogues1
            case "IE": return Layouts.InterviewEnglish
            case "CC": return Layouts.CabinCrew
            case "GME": return Layouts.GlobalMedicalEnglish
            case "IELTS1": return Layouts.IELTSOne
            case "FSIC1": return Layouts.FirstStepInConversation1
            case "Milestone1": return Layouts.Milestone1
            case "SP": return Layouts.SpeakingPattern
            }
        }
    }
}
</script>
